import { axiosObject } from "../config";

export default function login(form: any) {
  let payload = {
    type: "email",
    value: form.value.email.toLocaleLowerCase(),
    password: form.value.password,
  };
  console.log("payload::>", payload)
  return new Promise((resolve, reject) => {
    let uri = "access/login";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "AttributeNotVerified") {
            reject(errors.response.data);
          } else {
            form.setErrors({ password: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}
